export const infoMessage = {
  COPY_SUCCESS: 'Copied to the clipboard',
  TEST_WITH_TITLE_EXIST_MESSAGE:
    'A test with that name already exists in this department. Please choose a different name',
  EMPTY_TEST: 'Question was not selected',
  TEMPLATE_DUPLICATED_MESSAGE: 'A duplicate template has been created',
};
